import React from 'react'
import {Highlights} from "./content";
import {AccordianSection} from "./accordian-section";

export const Projects=({projects})=>{

    return <React.Fragment>
        {projects&&projects.map(el=><AccordianSection heading={el.heading} component={<React.Fragment><div>{el.subHeading1}</div><div>{el.description}</div></React.Fragment>}/>)}
    </React.Fragment>

}
